<template>
  <div>
    <Head title="Presumed Losses Gains"/>
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" :href="`/stocktake-references/${stocktake_ref}/features/${slug}`">{{ stocktakeTitle }}</Link>
      <span class="text-orange-400 font-medium">/</span> Presumed Losses/Gains
    </h1>
    <ul class="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 mb-4" id="tabs-tabFill"
      role="tablist">
      <li class="nav-item flex-auto text-center" role="presentation">
        <a href="#tabs-homeFill" class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
          active
        " id="tabs-home-tabFill" data-bs-toggle="pill" data-bs-target="#tabs-homeFill" role="tab"
          aria-controls="tabs-homeFill" aria-selected="true">Gains
        </a>
      </li>
      <li
        class="nav-item flex-auto text-center" role="presentation">
        <a href="#tabs-profileFill" class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
        " id="tabs-profile-tabFill" data-bs-toggle="pill" data-bs-target="#tabs-profileFill" role="tab"
          aria-controls="tabs-profileFill" aria-selected="false">Losses</a>
      </li>
    </ul>
    <div
      class="tab-content" id="tabs-tabContentFill"
    >
      <div class="tab-pane fade show active" id="tabs-homeFill" role="tabpanel" aria-labelledby="tabs-home-tabFill">
        <div class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">UID</th>
              <th class="pb-3 pt-3 px-3">Part Number</th>
              <th class="pb-3 pt-3 px-3">Part Description</th>
              <th class="pb-3 pt-3 px-3">Status</th>
              <th class="pb-3 pt-3 px-3"></th>
            </tr>
            <tr v-for="itemg in item_gains.data" :key="itemg.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <span class="flex items-center px-6 py-4 focus:text-indigo-500" tabindex="-1">
                  {{ itemg.name }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-6 py-4 focus:text-indigo-500" tabindex="-1">
                  {{ itemg.sku }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-6 py-4 focus:text-indigo-500" tabindex="-1">
                  {{ itemg.description }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-6 py-4 focus:text-indigo-500" tabindex="-1">
                  {{ itemg.status }}
                </span>
              </td>
              <td class="w-px border-t">
                <a href="#" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-orange-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange sm:text-sm sm:leading-5" @click="openGainModal(itemg)">
                  Receive
                </a>
              </td>
            </tr>
            <tr v-if="item_gains.data.length === 0">
              <td class="px-3 py-3 border-t" colspan="4">No data found</td>
            </tr>
          </table>
        <pagination class="mt-6" :links="item_gains.links" />
      </div>
        <!--modal content-->
        <div class="fixed z-10 inset-0 overflow-y-auto" v-if="isGainOpen">
          <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div class="fixed inset-0 transition-opacity">
              <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>
            <!-- This element is to trick the browser into centering the modal contents. -->
            <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
            <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
              <form>
                <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div class="mb-4">
                    <text-input v-model="name" type="text" class="pb-8 pr-6 w-full lg:w-full" label="UID" />
                    <text-input v-model="form.quantity" type="text" :error="errors.quantity" class="pb-8 pr-6 w-full lg:w-full" label="Quantity" />
                  </div>
                </div>
              <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
                  <button type="button" @click="updateQuantity()" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-orange-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange sm:text-sm sm:leading-5">
                    Receive
                  </button>
                </span>
                <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
                  <button @click="closeGainModal" type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5">
                    Cancel
                  </button>
                </span>
              </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        class="tab-pane fade" id="tabs-profileFill" role="tabpanel" aria-labelledby="tabs-profile-tabFill">
        <div class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">UID</th>
              <th class="pb-3 pt-3 px-3">Part Number</th>
              <th class="pb-3 pt-3 px-3">Part Description</th>
              <th class="pb-3 pt-3 px-3">Status</th>
              <th class="pb-3 pt-3 px-3"></th>
            </tr>
            <tr v-for="item in item_losses.data" :key="item.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <span class="flex items-center px-6 py-4 focus:text-indigo-500" tabindex="-1">
                  {{ item.name }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-6 py-4 focus:text-indigo-500" tabindex="-1">
                  {{ item.sku }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-6 py-4 focus:text-indigo-500" tabindex="-1">
                  {{ item.description }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-6 py-4 focus:text-indigo-500" tabindex="-1">
                  {{ item.status }}
                </span>
              </td>
              <td class="w-px border-t">
                <a v-show= "item.is_lost == 'no'" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-orange-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange sm:text-sm sm:leading-5" href="#" @click="openModal(item)">
                  Mark as Lost
                </a>
              </td>
            </tr>
            <tr v-if="item_losses.data.length === 0">
              <td class="px-3 py-3 border-t" colspan="4">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="item_losses.links" />
      </div>
    </div>
  </div>
  <!--modal content-->
  <div class="fixed z-10 inset-0 overflow-y-auto" v-if="isOpen">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <p>
                You are about to mark a UID {{ lostUid }} as <strong>LOST</strong>. Do you wish to continue?
              </p>
            </div>
          </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
            <button type="button" @click="markAsLost()" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-orange-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange sm:text-sm sm:leading-5">
              Yes
             </button>
           </span>
          <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
            <button @click="closeModal" type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5">
              No
            </button>
          </span>
        </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
//import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import mapValues from 'lodash/mapValues'
import SearchWithDateRange from '@/Shared/SearchWithDateRange'
import Pagination from '@/Shared/Pagination'
import TextInput from '@/Shared/TextInput'

export default {
  components: {
    Head,
    //Icon,
    Link,
    SearchWithDateRange,
    Pagination,
    TextInput,
  },
  layout: Layout,
  props: {
    filters: Object,
    item_losses: Object,
    item_gains: Object,
    stocktakeTitle: String,
    slug: String,
    stocktake_ref: Number,
    coverage_label: String,
    errors: Object,
  },
  data() {
    return {
      search: {
        search: this.filters.search,
      },
      show: false,
      isOpen: false,
      isGainOpen:false,
      uid: null,
      lostUid: null,
      name: null,
      quantity: null,
      form: this.$inertia.form({
        uid: null,
        quantity: null,
      }),
    }
  },
  methods: {
    reset() {
      this.search = mapValues(this.search, () => null)
    },
    updateQuantity() {
      const data = {};
      data.item_id = this.uid;
      data.quantity = this.form.quantity;
      data._method = 'POST';
      this.form.transform(({...data }) => ({
        _method: 'POST',
        item_id: this.uid,
        stocktake_reference_id: this.stocktake_ref,
        ...data,
      }));
      this.form.post(`/presumed-gains/items/${data.item_id}`,  {
        onSuccess: () => {
          this.isGainOpen = false
          this.form.reset(
            'uid',
            'quantity',
          )
        }
      })

    },
    openGainModal(data) {
      this.isGainOpen = true;
      this.uid = data.id
      this.name = data.name
      this.form.quantity = data.quantity
    },
    closeGainModal() {
      this.isGainOpen = false;
    },
    markAsLost() {
      const data = {};
      data.item_id = this.uid;
      data.stocktake_reference_id = this.stocktake_ref;
      data._method = 'POST';
      this.$inertia.post(`/presumed-losses/items/${data.item_id}`, data)
      this.isOpen = false;
    },
    openModal(data) {
      this.isOpen = true;
      this.uid = data.id
      this.lostUid = data.name
    },
    closeModal() {
      this.isOpen = false;
    },
  },
}
</script>
